import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import "./Modal.css";
import "./HTMLLinksModalClass.css";
import MultiSelectModal from "./MultiSelectModal";
import ImageDialog from "./ImageDialog";
import GuideDownload from "./GuideDownload/GuideDownload";

import AlertModal from "./AlertModal";
import PromptModal from "./PromptModal";
import Common, {
  POI_IMAGES,
  DISTANCES,
} from "../../Common/Common";
//import { setKey, shorten, expand } from "react-native-google-shortener";
// const [open, setOpen] = useState(false);
// const [value, setValue] = useState(null);
// const [items, setItems] = useState([
//   { label: "Apple", value: "apple" },
//   { label: "Banana", value: "banana" },
// ]);
import SectionsDialog from "./SectionsDialog";
import IconsDialog from "./IconsDialog";
import GoogleDrivePicker from "./GoogleDrivePicker";

class HTMLLinksModalClass extends Component {
  constructor(props) {
    super(props);
    //console.log("Itineraries", Itineraries);
    let items = [
      {
        label: "Place Link",
        name: "Place Link",
        value: "placelink",
        linkText: "Place ",
        icon: () => <FontAwesomeIcon icon={solid("check")} />,
      },
      {
        label: "Place More Info",
        name: "Place More Info",
        value: "placemoreinfolink",
        linkText: "More place info",
        icon: () => <FontAwesomeIcon icon={solid("check")} />,
      },
      {
        label: "Place Menu",
        name: "Place Menu",
        value: "placemenulink",
        icon: () => <FontAwesomeIcon icon={solid("check")} />,
      },
      // { label: "Places Filter", value: "placeslink", icon: () => <FontAwesomeIcon icon={solid("check")} /> },
      {
        label: "Section",
        name: "Section",
        value: "sectionlink",
        icon: () => <FontAwesomeIcon icon={solid("check")} />,
      },
      {
        label: "Schedule",
        name: "Schedule",
        value: "schedulelink",
        icon: () => <FontAwesomeIcon icon={solid("check")} />,
      },
      {
        label: "Itinerary",
        name: "Itinerary",
        value: "itinerarylink",
        icon: () => <FontAwesomeIcon icon={solid("check")} />,
      },

      { label: "Map", name: "Map", value: "maplink", icon: () => <FontAwesomeIcon icon={solid("check")} /> },
      {
        label: "Street View",
        name: "Street View",
        value: "streetviewlink",
        icon: () => <FontAwesomeIcon icon={solid("check")} />,
      },
      { label: "Guide", name: "Guide", value: "guidelink", icon: () => <FontAwesomeIcon icon={solid("check")} /> },
      { label: "Video", name: "Video", value: "videolink", icon: () => <FontAwesomeIcon icon={solid("check")} /> },
      // { label: "Video Path", name: "Video Path", value: "videopathlink", icon: () => <FontAwesomeIcon icon={solid("check")} /> },
      { label: "Audio", name: "Audio", value: "audiolink", icon: () => <FontAwesomeIcon icon={solid("check")} /> },
      { label: "PDF", name: "PDF", value: "pdflink", icon: () => <FontAwesomeIcon icon={solid("check")} /> },
      { label: "URL", name: "URL", value: "urllink", icon: () => <FontAwesomeIcon icon={solid("check")} /> },
      { label: "Flight", name: "Flight", value: "flightlink", icon: () => <FontAwesomeIcon icon={solid("check")} /> },
      { label: "Image", name: "Image", value: "imagelink", icon: () => <FontAwesomeIcon icon={solid("check")} /> },
      {
        label: "Directions",
        name: "Directions",
        value: "directionslink",
        icon: () => <FontAwesomeIcon icon={solid("check")} />,
      },
      {
        label: "Weather",
        name: "Weather",
        value: "weatherlink",
        icon: () => <FontAwesomeIcon icon={solid("check")} />,
      },
      {
        label: "Climate",
        name: "Climate",
        value: "climatelink",
        icon: () => <FontAwesomeIcon icon={solid("check")} />,
      },
    ];
    items = items.sort((a, b) => (a.label.toUpperCase() > b.label.toUpperCase() ? 1 : -1));

    this.state = {
      linkType: "Place Menu",
      linkName: "placemenulink",
      linkText: "Place Menu",
      // linkTextDisplayed: "Place Menu",
      url: "",
      PlaceIds: [],
      PlaceNames: [],
      Places: [],
      FromPlaceIds: [],
      FromPlaceNames: [],
      FromPlaces: [],
      GroupIds: [],
      GroupNames: [],
      Groups: [],
      CategoryIds: [],
      CategoryNames: [],
      Categories: [],
      sectionLink: "",
      sectionName: "",
      guideID: "",
      guideName: "",
      guide_info_id: "",
      imageURL: "http://andiamotravelapp.com/Images/App/IllustratedImage.jpg",
      imageUIURL: "http://andiamotravelapp.com/Images/App/IllustratedImage.jpg",
      linkIcon: { id: "1" },
      itineraryName: "Main",
      Itineraries: [],
      scheduleName: "Main",
      ShowOnlyFavorites: false,
      ShowOnlyVisited: false,
      ShowOnlyNotVisited: false,
      ShowOnlyMustSee: false,
      ScheduleFilter: false,
      DayFilter: false,
      day: "",
      distanceFilter: -1,
      DistanceSelected: "",
      imageSource: "Select Image",
      PickerItems: items,
      PickerValue: {
        label: "Place Menu",
        name: "Place Menu",
        value: "placemenulink",
        linkText: "Place Menu ",
        icon: () => <FontAwesomeIcon icon={solid("check")} />,
      },
      linkUI: "Text only",
      testWidth: "99%",

      AlertModalShow: false,
      AlertModalTitle: "",
      AlertModalMessage: "",
      AlertModalButtons: [],

      MultiselectItems: [],
      MultiselectSelectedItems: [],
      MultiselectMode: "uni",
      MultiselectCallback: null,
      MultiselectTitle: "Select",
      MultiselectSearchText: "",
      ShowMultiselect: false,

      PromptModalShow: false,
      PromptModalTitle: "Enter Value",
      PromptModalMessage: "",
      PromptModalButtons: [],
      PromptModalInputs: [],
      FilterOptions: [
        { name: "Show Only Favorites", value: "0", selected: false },
        { name: "Show Only Visited", value: "1", selected: false },
        { name: "Show Only Not Visited", value: "2", selected: false },
        { name: "Show Only Must See", value: "3", selected: false },
        { name: "Filter by Schedule", value: "4", selected: false },
        { name: "Filter by Day", value: "5", selected: false },
      ],
      UIOptionSelected: "0",
      ImageDialogShow: false,
      GuideDownloadShow: false,

      IconsDialogShow: false,
      video_start: 0,
      videoSource: "url",      gdriveFileId: "",
      gdriveFileName: "",
      audioSource: "url",
      gdriveAudioFileId: "",
      gdriveAudioFileName: "",
      pdfSource: "url",
      gdrivePdfFileId: "",
      gdrivePdfFileName: "",
      flightNumber: "",
    };
    this.handleChangeLinkText = this.handleChangeLinkText.bind(this);
    this.handleChangeURL = this.handleChangeURL.bind(this);
  }

  Itineraries = [];

  componentDidMount() {
    // if (window.guide_obj !== null) this.Itineraries = window.guide_obj.schedule.geScheduleNames();
  }

  handleChangeLinkText = (newText) => {
    console.log("newText", newText);
    this.setState({ ...this.state, linkText: newText });
  };

  handleChangeURL = (event) => {
    this.setState({ ...this.state, url: event.target.value });
  };

  HandleUIOptionSelected = (value) => {
    console.log("HandleUIOptionSelected", value, this.UIOptions[parseInt(value)].name);
    this.setState({ UIOptionSelected: value, linkUI: this.UIOptions[parseInt(value)].name });
    console.log(value, this.UIOptions[parseInt(value)].name);
  };

  MyAlert = (message) => {
    this.setState({
      AlertModalTitle: "Message",
      AlertModalMessage: message,
      AlertModalButtons: [{ Title: "OK", Method: null }],
      AlertModalShow: true,
    });
  };

  AddLink = (_this) => {
    if (this.state.linkText === "") {
      this.MyAlert("Must specify link text");
      return;
    }
    if (
      ["Place Link", "Place More Info", "Place Menu", "Street View", "Directions", "Weather", "Climate"].includes(
        this.state.linkType
      ) &&
      this.state.PlaceIds.length === 0
    ) {
      this.MyAlert("Must select a place");
      return;
    }
    //console.log(`PlaceIds: ${this.state.PlaceIds} Places: ${this.state.Places}`);
    //console.log(`linkName: ${this.state.linkName} linkType: ${this.state.linkType}`);
    let link = `${this.state.linkName}:`;
    switch (this.state.linkName) {
      case "placemoreinfolink":
        link += this.state.PlaceIds[0];
        break;
      case "placemenulink":
        link += this.state.PlaceIds[0];
        break;
      case "placelink":
        link += this.state.PlaceIds[0];
        break;
      case "placeslink":
        link += this.state.PlaceIds.join(",");
        break;
      case "schedulelink":
        link += this.state.scheduleName;
        break;
      case "itinerarylink":
        link += this.state.itineraryName;
        break;
      case "homelink":
        link += "home";
        break;
      case "maplink":
        let filters = "";
        if (this.state.ScheduleFilter === true) filters += `|schedule=${this.state.scheduleName}`;
        if (this.state.DayFilter === true) {
          const date = new Date(this.state.day);
          const dayTime = date.getTime();
          filters += `|day=${dayTime}`;
        }
        if (this.state.ShowOnlyFavorites === true) filters += "|Favorites";
        if (this.state.ShowOnlyVisited === true) filters += "|Visited";
        if (this.state.ShowOnlyNotVisited === true) filters += "|NotVisited";
        if (this.state.ShowOnlyMustSee === true) filters += "|MustSee";
        if (this.state.distanceFilter != -1) filters += `|distance=${this.state.distanceFilter}`;
        link += `${this.state.PlaceIds.join(",")}|${this.displayIDList(this.state.Groups, ",")}|${this.displayIDList(
          this.state.Categories,
          ","
        )}${filters}`;
        //console.log("link", link);
        break;
      case "streetviewlink":
        link += this.state.PlaceIds[0];
        break;
      case "sectionlink":
        link += this.state.sectionLink;
        break;
      case "guidelink":
        link += this.state.guide_info_id;
        break;
      case "imagelink":
        if (this.state.imageSource === "Paste URL") link += this.state.url;
        else link += this.state.imageURL;
        break;
      case "videolink":
        if (this.state.videoSource === "gdrive") {
          if (!this.state.gdriveFileId) { this.MyAlert("Select a video from Google Drive first"); return; }
          link += `gdrive:${this.state.gdriveFileId}`;
        } else if (this.state.videoSource === "youtube") {
          const ytUrl = this.state.url;
          const vParam = ytUrl.match(/[?&]v=([^&]+)/);
          let videoId = vParam ? vParam[1] : null;
          if (!videoId) {
            const pathMatch = ytUrl.match(/(?:youtu\.be\/|\/(?:shorts|embed)\/)([^?&/]+)/);
            if (pathMatch) videoId = pathMatch[1];
          }
          if (!videoId) { this.MyAlert("Could not find a YouTube video ID in that URL"); return; }
          const start = parseInt(this.state.video_start, 10) || 0;
          link += start > 0 ? `https://youtu.be/${videoId}?t=${start}` : `https://youtu.be/${videoId}`;
        } else {
          let total_time = this.state.video_start;
          if (this.state.video_start.includes(":")) {
            try {
              let time_parts = this.state.video_start.split(":");
              if (time_parts.length === 2) {
                total_time = parseInt(time_parts[0]) * 60 + parseInt(time_parts[1]);
              } else if (time_parts.length === 3) {
                total_time = parseInt(time_parts[0]) * 3600 + parseInt(time_parts[1]) * 60 + parseInt(time_parts[2]);
              }
            } catch {
              total_time = this.state.video_start;
            }
          }
          if (this.state.url.includes("https://www.youtu") || this.state.url.includes("https://youtu"))
            link += this.state.url + `?start=${total_time}&autoplay=1&mute=1`;
          else link += this.state.url;
        }
        break;
      case "pdflink":
        if (this.state.pdfSource === "gdrive") {
          if (!this.state.gdrivePdfFileId) { this.MyAlert("Select a PDF from Google Drive first"); return; }
          link += `gdrive:${this.state.gdrivePdfFileId}`;
        } else {
          if (!this.state.url) { this.MyAlert("Must specify a PDF URL"); return; }
          link += this.state.url;
        }
        break;
      case "audiolink":
        if (this.state.audioSource === "gdrive") {
          if (!this.state.gdriveAudioFileId) { this.MyAlert("Select an audio file from Google Drive first"); return; }
          link += `gdrive:${this.state.gdriveAudioFileId}`;
        } else {
          link += this.state.url;
        }
        break;
      case "urllink":
        if (this.state.url === "") {
          this.MyAlert("Must specify url");
          return;
        }
        link += this.state.url;
        break;
      case "flightlink": {
        const fn = this.state.flightNumber.trim().toUpperCase().replace(/\s+/g, "");
        if (!fn) { this.MyAlert("Must specify flight number"); return; }
        link = `urllink:https://www.flightaware.com/live/flight/${fn}`;
        break;
      }
      case "directionslink":
        if (this.state.FromPlaceIds.length === 0) {
          this.MyAlert("Must specify from place");
          return;
        }
        if (this.state.PlaceIds.length === 0) {
          this.MyAlert("Must specify to place");
          return;
        }
        link += this.state.FromPlaceIds[0] + "|" + this.state.PlaceIds[0];
        break;
      case "weatherlink":
        link += this.state.PlaceIds[0];
        break;
      case "climatelink":
        link += this.state.PlaceIds[0];
        break;
      default:
        break;
    }
    //console.log("AddLink", `${this.state.linkText}: ${link}}`);
    const callback = this.props.callback;
    if (callback == null) {
      //console.log("No callback from LinkdDialog");
      return;
    }
    let _linkIcon = "";
    if (typeof this.state.linkIcon.obj !== "undefined") {
      if (typeof this.state.linkIcon.obj.url !== "undefined") _linkIcon = this.state.linkIcon.obj.url;
    } else _linkIcon = POI_IMAGES[this.state.linkIcon.id].req;
    callback({
      text: this.state.linkText,
      url: link,
      linkUI: this.state.linkUI,
      imgURL: this.state.UIOptionSelected === "1" ? this.state.imageUIURL : _linkIcon,
      imageWidth: "300",
    });

    this.props.onHide();
  };

  StartTimeChanged = (event) => {
    const newText = event.target.value;
    if (newText != "") {
      var re = /^[0-9:]+$/;
      if (!re.test(newText)) return;
    }
    this.setState({ video_start: newText });
  };

  selectCategories = () => {
    this.MultiSelect(
      window.guide_obj.getCategoriesToDisplay(),
      this.state.Categories,
      "multi",
      this.selectCategoriesCallBack,
      "Select Categories"
    );
  };

  selectCategoriesCallBack = (Categories) => {
    if (Categories.length > 0) this.setState({ linkText: Categories[0].label });
    this.setState({ Categories: Categories });
  };

  MultiSelect = (Items, SelectedItems, Mode, Callback, Title) => {
    console.log("MultiSelect");
    this.setState({
      MultiselectItems: Items,
      MultiselectSelectedItems: SelectedItems,
      MultiselectMode: Mode,
      MultiselectCallback: Callback,
      MultiselectTitle: Title,
      MultiselectSearchText: "",
      ShowMultiselect: true,
    });
  };

  selectLinkType = () => {
    //console.log("selectLinkType");
    this.MultiSelect(this.state.PickerItems, this.state.PickerValue, "uni", this.selectLinkTypeCallBack, "Link Type");
  };

  selectLinkTypeCallBack = (links) => {
    console.log("selectLinkTypeCallBack", links);
    if (links.length > 0) {
      this.setState({
        PickerValue: links[0],
        linkText: links[0].label,
        // linkTextDisplayed: links[0].label,
        linkName: links[0].value,
        linkType: links[0].label,
      });
      if (
        ["placelink", "placemenulink", "placemoreinfolink", "directionslink", "streetviewlink"].includes(
          links[0].value
        ) &&
        this.state.Places.length > 1
      ) {
        this.setState({
          Places: [this.state.Places[0]],
          linkText: this.state.Places[0].label,
          // linkTextDisplayed: this.state.Places[0].label,
        });
      }
    }
  };

  filterByDistance = () => {
    let distancesList = [];
    let id = 0;
    DISTANCES.forEach((distance) => {
      distancesList.push({
        label: `${distance.toString()} km/${(distance * 0.621371).toFixed(2)} mi`,
        value: distance,
        id: (id++).toString(),
      });
    });
    let selectedDistance = [];
    if (this.state.distanceFilter !== -1)
      selectedDistance = [
        {
          label: `${this.state.distanceFilter.toString()} km/${(this.state.distanceFilter * 0.621371).toFixed(
            2
          )} mi`,
          value: this.state.distanceFilter,
        },
      ];
    this.MultiSelect(distancesList, selectedDistance, "uni", this.FilterDistanceCallBack, "Select Distance");
  };

  FilterDistanceCallBack = (ret) => {
    this.setState({ distanceFilter: ret[0].value, DistanceSelected: ret[0].label });
  };

  selectGroups = () => {
    this.MultiSelect(
      window.guide_obj.getGroupsToDisplay(),
      this.state.Groups,
      "multi",
      this.selectGroupsCallBack,
      "Select Groups"
    );
  };

  selectGroupsCallBack = (Groups) => {
    // let groups = [];
    // for (let i = 0; i < Groups.length; i++) {
    //   groups.push(Groups[i].label);
    // }
    console.log("Groups", Groups);
    if (Groups.length > 0) this.setState({ linkText: Groups[0].label });
    this.setState({ Groups: Groups });
  };
  selectDay = () => {
    const days = window.guide_obj.getChooseDatesList(this.state.ScheduleName);
    this.MultiSelect(
      days,
      [{ label: this.state.day, value: this.state.day }],
      "uni",
      this.selectDayCallBack,
      "Select day"
    );
  };

  selectDayCallBack = (days) => {
    //console.log("FilterDatesCallBack", days);
    if (days.length > 0) this.setState({ day: days[0].label });
  };

  selectSchedule = () => {
    const schedules = window.guide_obj.schedule.geScheduleNames();
    this.MultiSelect(
      schedules,
      [{ label: this.state.scheduleName, value: this.state.scheduleName }],
      "uni",
      this.selectScheduleCallBack,
      "Select Schedule"
    );
  };

  selectScheduleCallBack = (schedules) => {
    //console.log("selectScheduleCallBack", itineraries[0].label);
    if (schedules.length > 0)
      this.setState({
        scheduleName: schedules[0].label,
        linkText: schedules[0].label,
        // linkTextDisplayed: schedules[0].label,
      });
  };

  selectItinerary = () => {
    const schedules = window.guide_obj.schedule.geScheduleNames();
    this.MultiSelect(
      schedules,
      [{ label: this.state.itineraryName, value: this.state.itineraryName }],
      "uni",
      this.selectItineraryCallBack,
      "Select Itinerary"
    );
  };

  selectItineraryCallBack = (itineraries) => {
    //console.log("selectScheduleCallBack", itineraries[0].label);
    if (itineraries.length > 0)
      this.setState({
        itineraryName: itineraries[0].label,
        linkText: itineraries[0].label,
        // linkTextDisplayed: itineraries[0].label,
      });
  };

  displayIDList(arr, sep) {
    if (sep == null) sep = ", ";
    let str = "";
    for (let i = 0; i < arr.length; i++) {
      if (str != "") str += sep;
      str += arr[i].value.id;
    }
    //console.log("displayIDList", arr, str);
    return str;
  }

  displayValueList(arr, sep) {
    if (sep == null) sep = ", ";
    let str = "";
    for (let i = 0; i < arr.length; i++) {
      if (str != "") str += sep;
      str += arr[i].label;
    }
    //console.log("displayValueList", arr, str);
    return str;
  }

  selectPlacesUni = () => {
    this._fromPlace = false;
    this.selectPlaces("uni");
  };

  selectPlacesMulti = () => {
    this._fromPlace = false;
    this.selectPlaces("multi");
  };

  _fromPlace = false;

  selectPlacesUniFrom = () => {
    this._fromPlace = true;
    this.selectPlaces("uni");
  };

  selectPlaces = (mode) => {
    this.MultiSelect(
      window.guide_obj.places.getPlacesToDisplay(null),
      this.state.Places,
      mode,
      this.selectPlacesCallBack,
      "Places"
    );
  };

  selectPlacesCallBack = (Places) => {
    //console.log(Places);
    //if (Places === null) return;
    //if (Places.length === 0) return;
    let placeIds = [];
    let placeNames = [];
    Places.forEach((place) => {
      placeIds.push(place.value);
      placeNames.push(place.label);
    });
    //console.log("placeIds", placeIds);
    if (this._fromPlace === true) {
      this._fromPlace = false;
      this.setState({ FromPlaces: Places, FromPlaceIds: placeIds, FromPlaceNames: placeNames });
      if (Places.length > 0 && this.state.PlaceNames.length > 0)
        this.setState({
          linkText: `From ${Places[0].label} to ${this.state.PlaceNames[0]}`,
          // linkTextDisplayed: `From ${Places[0].label} to ${this.state.PlaceNames[0]}`,
        });
    } else {
      this.setState({ Places: Places, PlaceIds: placeIds, PlaceNames: placeNames });
      if (Places.length > 0 && this.state.FromPlaceNames.length > 0)
        this.setState({
          linkText: `From ${this.state.FromPlaceNames[0]} to ${Places[0].label}`,
          // linkTextDisplayed: `From ${this.state.FromPlaceNames[0]} to ${Places[0].label}`,
        });
      else if (Places.length > 0) this.setState({ linkText: Places[0].label });
    }
  };

  _imageType = "link";

  selectImageLinkURL = () => {
    this.setState({
      PromptModalShow: true,
      PromptModalTitle: "Image URL",
      PromptModalMessage: "Enter Image URL",
      PromptModalButtons: [
        { Title: "OK", Method: this.changeImageURL },
        { Title: "CANCEL", Method: null },
      ],
      PromptModalInputs: [{ name: "Image URL", value: this.state.imageURL }],
    });
  };

  changeImageURL = (inputs) => {
    if (inputs === null) return;
    this.setState({ imageURL: inputs[0].value });
  };

  selectImageUIURL = () => {
    this.setState({
      PromptModalShow: true,
      PromptModalTitle: "Image URL",
      PromptModalMessage: "Enter Image URL",
      PromptModalButtons: [
        { Title: "OK", Method: this.changeImageUIURL },
        { Title: "CANCEL", Method: null },
      ],
      PromptModalInputs: [{ name: "Image URL", value: this.state.imageURL }],
    });
  };

  changeImageUIURL = (inputs) => {
    if (inputs === null) return;
    this.setState({ imageUIURL: inputs[0].value });
  };

  selectImageUI = () => {
    this.selectImage("ui");
  };

  selectIcon = () => {
    this.setState({ IconsDialogShow: true });
  };

  UpdateIcon = (icon) => {
    console.log("UpdateIcon", icon);
    this.setState({ linkIcon: icon });
  };

  selectImageLink = () => {
    console.log("selectImageLink");
    this.selectImage("link");
  };

  selectImage = (type) => {
    console.log("selectImage");
    this._imageType = type;
    this.setState({
      ImageDialogShow: true,
    });
    // this.props.navigation.navigate("ImageDialog", {
    //   mode: "select",
    //   size: "medium",
    //   multi: false,
    //   updateImage: this.updateImageCallBack,
    // });
  };

  updateImageCallBack = (imageInfo) => {
    console.log("updateImageCallBack", imageInfo, this._imageType);
    if (imageInfo.length === 0) return;
    if (this._imageType === "link") {
      if (imageInfo[0].url_m !== "") this.setState({ imageURL: imageInfo[0].url_m });
      else this.setState({ imageURL: imageInfo[0].url });
    } else {
      if (imageInfo[0].url_m !== "") this.setState({ imageURL: imageInfo[0].url });
      else this.setState({ imageURL: imageInfo[0].url_m });
    }
  };

  getImageURLString = (str) => {
    const url = Common.getImageURL(str, null, true);
    //console.log(url);
    return url;
  };

  selectAudio = () => {
    //console.log("selectAudio");
  };

  selectVideo = () => {
    //console.log("selectVideo");
  };

  selectGuide = () => {
    this.setState({ GuideDownloadShow: true });
  };

  selectGuideCallback = (guide_info_id, guide_id, guide_name) => {
    //console.log("selectGuideCallback", guide_id);
    this.setState({
      guideID: guide_id,
      guideName: guide_name,
      guide_info_id: guide_info_id,
    });
  };

  selectSection = () => {
    //console.log("selectSection");
    this.setState({ SectionsDialogShow: true });
    //this.props.navigation.navigate("SectionSelect", { callback: this.selectSectionCallback });
  };

  // selectSectionCallback = (section) => {
  //   let _sectionName = this.state.sectionName;
  //   if (_sectionName == "") _sectionName = section.Title;
  //   this.setState({ sectionLink: section.ID, sectionName: _sectionName });
  // };

  selectSectionCallback = (section) => {
    //console.log("selectSectionCallback", sectionLink, sectionName);
    //this._section = sectionLink;
    let _sectionName = this.state.sectionName;
    if (_sectionName === "") _sectionName = section.Title;
    this.setState({
      sectionLink: section.ID,
      sectionName: _sectionName,
      linkText: _sectionName,
      // linkTextDisplayed: _sectionName,
    });
  };

  updateShowOnlyFavorites = (value) => {
    this.setState({ ShowOnlyFavorites: value });
  };

  updateShowOnlyVisited = (value) => {
    this.setState({ ShowOnlyVisited: value });
  };

  updateShowOnlyNotVisited = (value) => {
    this.setState({ ShowOnlyNotVisited: value });
  };

  updateShowOnlyMustSee = (value) => {
    this.setState({ ShowOnlyMustSee: value });
  };

  updateScheduleFilter = (value) => {
    this.setState({ ScheduleFilter: value });
  };

  updateDayFilter = (value) => {
    this.setState({ DayFilter: value });
  };

  yes_no_props = [
    { label: "Yes  ", value: true },
    { label: "No  ", value: false },
  ];

  imageSourceMode = (value) => {
    this.setState({ imageSource: value });
  };

  selectLinkUI = (value) => {
    //console.log("selectLinkUI", value);
    //this.setState({ linkUI: value });
  };

  openClosePicker = () => {
    this.setState({ DisplayPicker: !this.state.DisplayPicker });
  };

  setPickerValue = (value) => {
    //console.log("setPickerValue", value);
    this.setState({ PickerValue: value });
  };

  setPickerItems = (value) => {
    //console.log("setPickerItems", value);
    this.setState({ PickerItems: value });
  };

  UIOptions = [
    { name: "Text only", value: "0" },
    { name: "With Image", value: "1" },
    { name: "With Button", value: "2" },
    { name: "With Icon", value: "3" },
  ];

  FilterOptionSelected = (index) => {
    let filters = this.state.FilterOptions.map((f) => ({ ...f }));
    filters[index].selected = !filters[index].selected;
    //this.setState({ FilterOptions: filters });
    //console.log("FilterOptionSelected", filters);

    let _DayFilter = this.FilterOptionChoosen("Filter by Day", filters);
    //SetFilterByDay(_FilterByDay);
    let _ScheduleFilter = this.FilterOptionChoosen("Filter by Schedule", filters);
    //SetFilterBySchedule(_FilterBySchedule);

    if (_DayFilter) filters = filters.filter((x) => x.name !== "Filter by Schedule");
    else if (_ScheduleFilter) filters = filters.filter((x) => x.name !== "Filter by Day");
    else {
      let index = filters.findIndex((x) => x.name === "Filter by Schedule");
      if (index === -1) filters.push({ name: "Filter by Schedule", value: "4", selected: false });
      index = filters.findIndex((x) => x.name === "Filter by Day");
      if (index === -1) filters.push({ name: "Filter by Day", value: "5", selected: false });
      console.log("FilterOptionSelected", filters);
    }

    let ShowOnlyFavorites = false;
    let ShowOnlyVisited = false;
    let ShowOnlyNotVisited = false;
    let ShowOnlyMustSee = false;
    let ScheduleFilter = false;
    let DayFilter = false;
    filters.forEach((filter) => {
      if (filter.value === "0") ShowOnlyFavorites = filter.selected;
      if (filter.value === "1") ShowOnlyVisited = filter.selected;
      if (filter.value === "2") ShowOnlyNotVisited = filter.selected;
      if (filter.value === "3") ShowOnlyMustSee = filter.selected;
      if (filter.value === "4") ScheduleFilter = filter.selected;
      if (filter.value === "5") DayFilter = filter.selected;
    });
    filters = filters.sort((a, b) => (parseInt(a.value) > parseInt(b.value) ? 1 : -1));
    this.setState({
      FilterOptions: filters,
      DayFilter: _DayFilter,
      ScheduleFilter: _ScheduleFilter,
      ShowOnlyFavorites: ShowOnlyFavorites,
      ShowOnlyVisited: ShowOnlyVisited,
      ShowOnlyNotVisited: ShowOnlyNotVisited,
      ShowOnlyMustSee: ShowOnlyMustSee,
      // ScheduleFilter: ScheduleFilter,
      // DayFilter: DayFilter,
    });

    // setTimeout(() => {
    //   // CheckFilterOptions1();
    // }, 100);
  };

  FilterOptionChoosen = (name, options) => {
    const option = options.findIndex((x) => x.name === name && x.selected === true);
    if (option !== -1) return true;
    else return false;
  };

  closeModal = () => {
    console.log("closeModal");
    this.props.onHide();
  };

  linkTypeChange = (event) => {
    console.log("linkTypeChange", event.target.value);
    this.state.PickerItems.forEach((item) => {
      if (item.label === event.target.value) this.selectLinkTypeCallBack([item]);
    });
  };

  render() {
    let icon_img_src = null;
    if (typeof this.state.linkIcon.obj !== "undefined") {
      if (typeof this.state.linkIcon.obj.url !== "undefined") icon_img_src = this.state.linkIcon.obj.url;
    } else icon_img_src = POI_IMAGES[this.state.linkIcon.id].req;

    if (this.state.ShowMultiselect)
      return (
        <MultiSelectModal
          show={this.state.ShowMultiselect}
          onHide={() => this.setState({ ShowMultiselect: false })}
          MultiselectItems={this.state.MultiselectItems}
          MultiselectSelectedItems={this.state.MultiselectSelectedItems}
          MultiselectMode={this.state.MultiselectMode}
          MultiselectCallback={this.state.MultiselectCallback}
          MultiselectTitle={this.state.MultiselectTitle}
          MultiselectSearchText={this.state.MultiselectSearchText}
        />
      );

    if (this.state.ImageDialogShow)
      return (
        <ImageDialog
          show={this.state.ImageDialogShow}
          onHide={() => this.setState({ ImageDialogShow: false })}
          user_info={this.props.user_info}
          mode={"select"}
          modify_only={"true"}
          updateImage={this.updateImageCallBack}
          size={"sm"}
          multi={false}
          exif={false}
          folder={this.props.folder}
          setImageFolder={this.props.setImageFolder}
        />
      );

    return (
      <div style={{ zIndex: 65537 }}>
        <Modal
          {...this.props}
          dialogClassName="myModalClass hl-dialog"
          aria-labelledby="contained-modal-title-vcenter"
          scrollable={false}
          size={window.innerWidth < 450 ? "lg" : "md"}
          onHide={this.closeModal}
        >
          <Modal.Body style={{ padding: 0 }}>
            <div className="hl-shell">
              <div className="hl-header">
                <div className="hl-header-icon">
                  <FontAwesomeIcon icon={solid("link")} />
                </div>
                <span className="hl-title">Insert Link</span>
                <button className="hl-add-btn" onClick={this.AddLink}>Add</button>
                <button className="hl-close" onClick={this.closeModal}>
                  <FontAwesomeIcon icon={solid("xmark")} />
                </button>
              </div>

              <div className="hl-body">
                <div className="hl-field">
                  <span className="hl-label">Link type</span>
                  <select className="hl-select" onChange={this.linkTypeChange} defaultValue={this.state.linkType}>
                    <option value="Audio">Audio</option>
                    <option value="PDF">PDF</option>
                    <option value="Climate">Climate</option>
                    <option value="Directions">Directions</option>
                    <option value="Flight">Flight</option>
                    <option value="Guide">Guide</option>
                    <option value="Image">Image</option>
                    <option value="Itinerary">Itinerary</option>
                    <option value="Map">Map / Filter</option>
                    <option value="Place Link">Place Link</option>
                    <option value="Place Menu">Place Menu</option>
                    <option value="Place More Info">Place More Info</option>
                    <option value="Section">Section</option>
                    <option value="Schedule">Schedule</option>
                    <option value="Street View">Street View</option>
                    <option value="URL">URL</option>
                    <option value="Video">Video</option>
                    <option value="Weather">Weather</option>
                  </select>
                </div>

                <div className="hl-field">
                  <span className="hl-label">Display as</span>
                  <div className="hl-ui-toggle">
                    {this.UIOptions.map((option, idx) => (
                      <button
                        key={idx}
                        className={`hl-ui-btn${this.state.UIOptionSelected === option.value ? " active" : ""}`}
                        onClick={() => this.HandleUIOptionSelected(option.value)}
                      >
                        {option.name}
                      </button>
                    ))}
                  </div>
                </div>

                {["0", "1", "2"].includes(this.state.UIOptionSelected) && (
                  <div className="hl-field">
                    <span className="hl-label">Link text</span>
                    <input
                      className="hl-input"
                      type="text"
                      value={this.state.linkText}
                      onChange={(e) => this.handleChangeLinkText(e.target.value)}
                    />
                  </div>
                )}

                {this.state.UIOptionSelected === "1" && (
                  <div className="hl-field">
                    <span className="hl-label">Display image</span>
                    <div className="hl-btn-row">
                      <button className="hl-btn" onClick={() => this.selectImageUI()}>
                        <FontAwesomeIcon icon={solid("image")} className="hl-btn-icon" />
                        Select Image
                      </button>
                      <button className="hl-btn" onClick={() => this.selectImageUIURL()}>
                        <FontAwesomeIcon icon={solid("link")} className="hl-btn-icon" />
                        Enter URL
                      </button>
                    </div>
                    <div className="hl-image-preview">
                      <img src={this.state.imageUIURL} alt="" />
                    </div>
                  </div>
                )}

                {this.state.UIOptionSelected === "3" && (
                  <div className="hl-field">
                    <span className="hl-label">Icon</span>
                    <div className="hl-btn-row">
                      <button className="hl-btn" onClick={() => this.selectIcon()}>
                        <FontAwesomeIcon icon={solid("star")} className="hl-btn-icon" />
                        Select Icon
                      </button>
                    </div>
                    <div className="hl-icon-preview">
                      {icon_img_src && <img src={icon_img_src} alt="icon" />}
                    </div>
                  </div>
                )}

                {["Directions"].includes(this.state.linkType) && (
                  <div className="hl-field">
                    <span className="hl-label">From place</span>
                    <div className="hl-btn-row">
                      <button className="hl-btn" onClick={() => this.selectPlacesUniFrom()}>
                        <FontAwesomeIcon icon={solid("map-pin")} className="hl-btn-icon" />
                        Select From Place
                      </button>
                    </div>
                    {this.state.FromPlaces.length > 0 && (
                      <div className="hl-value">{this.displayValueList(this.state.FromPlaces)}</div>
                    )}
                  </div>
                )}

                {["Place Link", "Place More Info", "Place Menu", "Street View", "Directions", "Weather", "Climate", "Video Path"].includes(this.state.linkType) && (
                  <div className="hl-field">
                    <span className="hl-label">{["Directions"].includes(this.state.linkType) ? "To place" : "Place"}</span>
                    <div className="hl-btn-row">
                      <button className="hl-btn" onClick={() => this.selectPlacesUni()}>
                        <FontAwesomeIcon icon={solid("map-pin")} className="hl-btn-icon" />
                        {["Directions"].includes(this.state.linkType) ? "Select To Place" : "Select Place"}
                      </button>
                    </div>
                    {this.state.Places.length > 0 && (
                      <div className="hl-value">{this.displayValueList(this.state.Places)}</div>
                    )}
                  </div>
                )}

                {(["Schedule"].includes(this.state.linkType) || (["Map"].includes(this.state.linkType) && this.state.ScheduleFilter)) && (
                  <div className="hl-field">
                    <span className="hl-label">Schedule</span>
                    <div className="hl-btn-row">
                      <button className="hl-btn" onClick={() => this.selectSchedule()}>
                        <FontAwesomeIcon icon={solid("calendar")} className="hl-btn-icon" />
                        Select Schedule
                      </button>
                    </div>
                    {this.state.scheduleName && <div className="hl-value">{this.state.scheduleName}</div>}
                  </div>
                )}

                {["Map"].includes(this.state.linkType) && this.state.DayFilter && (
                  <div className="hl-field">
                    <span className="hl-label">Day</span>
                    <div className="hl-btn-row">
                      <button className="hl-btn" onClick={() => this.selectDay()}>
                        <FontAwesomeIcon icon={solid("calendar-day")} className="hl-btn-icon" />
                        Select Day
                      </button>
                    </div>
                    {this.state.day && <div className="hl-value">{this.state.day}</div>}
                  </div>
                )}

                {["Image"].includes(this.state.linkType) && (
                  <div className="hl-field">
                    <span className="hl-label">Image</span>
                    <div className="hl-btn-row">
                      <button className="hl-btn" onClick={() => this.selectImageLink()}>
                        <FontAwesomeIcon icon={solid("image")} className="hl-btn-icon" />
                        Select Image
                      </button>
                      <button className="hl-btn" onClick={() => this.selectImageLinkURL()}>
                        <FontAwesomeIcon icon={solid("link")} className="hl-btn-icon" />
                        Enter URL
                      </button>
                    </div>
                    <div className="hl-image-preview">
                      <img src={this.state.imageURL} alt="" />
                    </div>
                  </div>
                )}

                {["Flight"].includes(this.state.linkType) && (
                  <div className="hl-field">
                    <span className="hl-label">Flight number</span>
                    <input
                      className="hl-input"
                      type="text"
                      placeholder="e.g. AA123"
                      value={this.state.flightNumber}
                      onChange={(e) => this.setState({ flightNumber: e.target.value })}
                    />
                  </div>
                )}

                {["URL"].includes(this.state.linkType) && (
                  <div className="hl-field">
                    <span className="hl-label">URL</span>
                    <textarea
                      className="hl-textarea"
                      rows={4}
                      onChange={this.handleChangeURL}
                      placeholder="Paste URL here"
                    />
                  </div>
                )}

                {["Audio"].includes(this.state.linkType) && (
                  <div className="hl-field">
                    <span className="hl-label">Source</span>
                    <div className="hl-ui-toggle">
                      <button
                        className={`hl-ui-btn${this.state.audioSource === "url" ? " active" : ""}`}
                        onClick={() => this.setState({ audioSource: "url", gdriveAudioFileId: "", gdriveAudioFileName: "" })}
                      >
                        URL
                      </button>
                      <button
                        className={`hl-ui-btn${this.state.audioSource === "gdrive" ? " active" : ""}`}
                        onClick={() => this.setState({ audioSource: "gdrive", url: "" })}
                      >
                        Google Drive
                      </button>
                    </div>
                  </div>
                )}

                {["Audio"].includes(this.state.linkType) && this.state.audioSource === "url" && (
                  <div className="hl-field">
                    <span className="hl-label">URL</span>
                    <textarea
                      className="hl-textarea"
                      rows={4}
                      onChange={this.handleChangeURL}
                      placeholder="Paste URL here"
                    />
                  </div>
                )}

                {["Audio"].includes(this.state.linkType) && this.state.audioSource === "gdrive" && (
                  <div className="hl-field">
                    <span className="hl-label">Audio</span>
                    {this.state.gdriveAudioFileId ? (
                      <>
                        <div className="hl-value">🎵 {this.state.gdriveAudioFileName}</div>
                        <div className="hl-btn-row">
                          <button className="hl-btn" onClick={() => this.setState({ gdriveAudioFileId: "", gdriveAudioFileName: "" })}>
                            Change
                          </button>
                        </div>
                      </>
                    ) : (
                      <GoogleDrivePicker
                        fileType="audio"
                        multi={false}
                        onSelect={(items) => {
                          if (items.length === 0) return;
                          const fileId = items[0].url.replace("gdrive:", "");
                          this.setState({ gdriveAudioFileId: fileId, gdriveAudioFileName: items[0].name });
                        }}
                      />
                    )}
                  </div>
                )}

                {["PDF"].includes(this.state.linkType) && (
                  <div className="hl-field">
                    <span className="hl-label">Source</span>
                    <div className="hl-ui-toggle">
                      <button
                        className={`hl-ui-btn${this.state.pdfSource === "url" ? " active" : ""}`}
                        onClick={() => this.setState({ pdfSource: "url", gdrivePdfFileId: "", gdrivePdfFileName: "" })}
                      >
                        URL
                      </button>
                      <button
                        className={`hl-ui-btn${this.state.pdfSource === "gdrive" ? " active" : ""}`}
                        onClick={() => this.setState({ pdfSource: "gdrive", url: "" })}
                      >
                        Google Drive
                      </button>
                    </div>
                  </div>
                )}

                {["PDF"].includes(this.state.linkType) && this.state.pdfSource === "url" && (
                  <div className="hl-field">
                    <span className="hl-label">URL</span>
                    <textarea
                      className="hl-textarea"
                      rows={4}
                      onChange={this.handleChangeURL}
                      placeholder="Paste PDF URL here"
                    />
                  </div>
                )}

                {["PDF"].includes(this.state.linkType) && this.state.pdfSource === "gdrive" && (
                  <div className="hl-field">
                    <span className="hl-label">PDF</span>
                    {this.state.gdrivePdfFileId ? (
                      <>
                        <div className="hl-value">📄 {this.state.gdrivePdfFileName}</div>
                        <div className="hl-btn-row">
                          <button className="hl-btn" onClick={() => this.setState({ gdrivePdfFileId: "", gdrivePdfFileName: "" })}>
                            Change
                          </button>
                        </div>
                      </>
                    ) : (
                      <GoogleDrivePicker
                        fileType="pdf"
                        multi={false}
                        onSelect={(items) => {
                          if (items.length === 0) return;
                          const fileId = items[0].url.replace("gdrive:", "");
                          this.setState({ gdrivePdfFileId: fileId, gdrivePdfFileName: items[0].name });
                        }}
                      />
                    )}
                  </div>
                )}

                {["Video", "Video Path"].includes(this.state.linkType) && (
                  <div className="hl-field">
                    <span className="hl-label">Source</span>
                    <div className="hl-ui-toggle">
                      <button
                        className={`hl-ui-btn${this.state.videoSource === "youtube" ? " active" : ""}`}
                        onClick={() => this.setState({ videoSource: "youtube", gdriveFileId: "", gdriveFileName: "", url: "" })}
                      >
                        YouTube
                      </button>
                      <button
                        className={`hl-ui-btn${this.state.videoSource === "gdrive" ? " active" : ""}`}
                        onClick={() => this.setState({ videoSource: "gdrive", url: "" })}
                      >
                        Google Drive
                      </button>
                      <button
                        className={`hl-ui-btn${this.state.videoSource === "url" ? " active" : ""}`}
                        onClick={() => this.setState({ videoSource: "url", gdriveFileId: "", gdriveFileName: "" })}
                      >
                        URL
                      </button>
                    </div>
                  </div>
                )}

                {["Video", "Video Path"].includes(this.state.linkType) && this.state.videoSource === "youtube" && (
                  <div className="hl-field">
                    <span className="hl-label">YouTube URL</span>
                    <textarea
                      className="hl-textarea"
                      rows={3}
                      onChange={this.handleChangeURL}
                      placeholder="Paste YouTube URL here"
                    />
                  </div>
                )}

                {["Video", "Video Path"].includes(this.state.linkType) && this.state.videoSource === "url" && (
                  <div className="hl-field">
                    <span className="hl-label">URL</span>
                    <textarea
                      className="hl-textarea"
                      rows={4}
                      onChange={this.handleChangeURL}
                      placeholder="Paste URL here"
                    />
                  </div>
                )}

                {["Video", "Video Path"].includes(this.state.linkType) && this.state.videoSource === "gdrive" && (
                  <div className="hl-field">
                    <span className="hl-label">Video</span>
                    {this.state.gdriveFileId ? (
                      <>
                        <div className="hl-value">🎬 {this.state.gdriveFileName}</div>
                        <div className="hl-btn-row">
                          <button className="hl-btn" onClick={() => this.setState({ gdriveFileId: "", gdriveFileName: "" })}>
                            Change
                          </button>
                        </div>
                      </>
                    ) : (
                      <GoogleDrivePicker
                        fileType="video"
                        multi={false}
                        onSelect={(items) => {
                          if (items.length === 0) return;
                          const fileId = items[0].url.replace("gdrive:", "");
                          this.setState({ gdriveFileId: fileId, gdriveFileName: items[0].name });
                        }}
                      />
                    )}
                  </div>
                )}

                {["Video", "Video Path"].includes(this.state.linkType) &&
                  (this.state.videoSource === "youtube" ||
                    (this.state.videoSource === "url" &&
                      (this.state.url.includes("https://www.youtu") || this.state.url.includes("https://youtu")))) && (
                  <div className="hl-field">
                    <span className="hl-label">Start time (seconds)</span>
                    <input
                      className="hl-input"
                      type="text"
                      placeholder="e.g. 90 or 1:30"
                      onChange={this.StartTimeChanged}
                    />
                  </div>
                )}

                {["Map", "Places Filter"].includes(this.state.linkType) && (
                  <>
                    <div className="hl-field">
                      <span className="hl-label">Places</span>
                      <div className="hl-btn-row">
                        <button className="hl-btn" onClick={() => this.selectPlacesMulti()}>
                          <FontAwesomeIcon icon={solid("map-pin")} className="hl-btn-icon" />
                          Select Places
                        </button>
                      </div>
                      {this.state.Places.length > 0 && (
                        <div className="hl-value">{this.displayValueList(this.state.Places)}</div>
                      )}
                    </div>
                    <div className="hl-field">
                      <span className="hl-label">Groups</span>
                      <div className="hl-btn-row">
                        <button className="hl-btn" onClick={() => this.selectGroups()}>
                          <FontAwesomeIcon icon={solid("layer-group")} className="hl-btn-icon" />
                          Select Groups
                        </button>
                      </div>
                      {this.state.Groups.length > 0 && (
                        <div className="hl-value">{this.displayValueList(this.state.Groups)}</div>
                      )}
                    </div>
                    <div className="hl-field">
                      <span className="hl-label">Categories</span>
                      <div className="hl-btn-row">
                        <button className="hl-btn" onClick={() => this.selectCategories()}>
                          <FontAwesomeIcon icon={solid("tags")} className="hl-btn-icon" />
                          Select Categories
                        </button>
                      </div>
                      {this.state.Categories.length > 0 && (
                        <div className="hl-value">{this.displayValueList(this.state.Categories)}</div>
                      )}
                    </div>
                    <div className="hl-field">
                      <span className="hl-label">Filters</span>
                      <div className="hl-checkbox-list">
                        {this.state.FilterOptions.map((element, index) => (
                          <label key={index} className="hl-checkbox-item">
                            <input
                              type="checkbox"
                              checked={element.selected}
                              onChange={() => this.FilterOptionSelected(index)}
                            />
                            <span className={element.selected ? "checked" : ""}>{element.name}</span>
                          </label>
                        ))}
                      </div>
                    </div>
                  </>
                )}

                {["Itinerary"].includes(this.state.linkType) && (
                  <div className="hl-field">
                    <span className="hl-label">Itinerary</span>
                    <div className="hl-btn-row">
                      <button className="hl-btn" onClick={() => this.selectItinerary()}>
                        <FontAwesomeIcon icon={solid("calendar")} className="hl-btn-icon" />
                        Select Itinerary
                      </button>
                    </div>
                    {this.state.itineraryName && <div className="hl-value">{this.state.itineraryName}</div>}
                  </div>
                )}

                {["Guide"].includes(this.state.linkType) && (
                  <div className="hl-field">
                    <span className="hl-label">Guide</span>
                    <div className="hl-btn-row">
                      <button className="hl-btn" onClick={() => this.selectGuide()}>
                        <FontAwesomeIcon icon={solid("book")} className="hl-btn-icon" />
                        Select Guide
                      </button>
                    </div>
                    {this.state.guideName && <div className="hl-value">{this.state.guideName}</div>}
                  </div>
                )}

                {["Section"].includes(this.state.linkType) && (
                  <div className="hl-field">
                    <span className="hl-label">Section</span>
                    <div className="hl-btn-row">
                      <button className="hl-btn" onClick={() => this.selectSection()}>
                        <FontAwesomeIcon icon={solid("list")} className="hl-btn-icon" />
                        Select Section
                      </button>
                    </div>
                    {this.state.sectionName && <div className="hl-value">{this.state.sectionName}</div>}
                  </div>
                )}
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <AlertModal
          show={this.state.AlertModalShow}
          onHide={() => this.setState({ AlertModalShow: false })}
          AlertModalTitle={this.state.AlertModalTitle}
          AlertModalMessage={this.state.AlertModalMessage}
          AlertModalButtons={this.state.AlertModalButtons}
        />
        {this.state.SectionsDialogShow ? (
          <SectionsDialog
            show={this.state.SectionsDialogShow}
            onHide={() => this.setState({ SectionsDialogShow: false })}
            update_display={null}
            mode={"select"}
            callback={this.selectSectionCallback}
          />
        ) : null}
        {this.state.GuideDownloadShow ? (
          <GuideDownload
            show={this.state.GuideDownloadShow}
            onHide={() => this.setState({ GuideDownloadShow: false })}
            user_info={this.props.user_info}
            guide_sort_option={[]}
            set_guide_sort_option={null}
            callback={this.selectGuideCallback}
            mode={"list"}
            modify_only={"false"}
            guide_meta={this.props.guide_meta}
            guide_type={this.props.guide_type}
          />
        ) : null}
        {this.state.IconsDialogShow ? (
          <IconsDialog
            show={this.state.IconsDialogShow}
            onHide={() => this.setState({ IconsDialogShow: false })}
            update_icon={this.UpdateIcon}
          />
        ) : null}
        <PromptModal
          show={this.state.PromptModalShow}
          onHide={() => this.setState({ PromptModalShow: false })}
          PromptModalTitle={this.state.PromptModalTitle}
          PromptModalMessage={this.state.PromptModalMessage}
          PromptModalButtons={this.state.PromptModalButtons}
          PromptModalInputs={this.state.PromptModalInputs}
          area={true}
        />
      </div>
    );
  }
}
export default HTMLLinksModalClass;
